import NativeOrWeb from '../utils/native';

export const LOGIN_BANNER_IMG = NativeOrWeb.isIOSPlatform() ? 'img/loginBanner_enterprise.png' : 'img/loginBanner.png';
